import { render } from "./FtjlList.vue?vue&type=template&id=528acebe&scoped=true"
import script from "./FtjlList.vue?vue&type=script&lang=js"
export * from "./FtjlList.vue?vue&type=script&lang=js"

import "./FtjlList.vue?vue&type=style&index=0&id=528acebe&lang=less&scoped=true"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528acebe"]])

export default __exports__